import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import App from "./App";
import { CompanyProvider } from "./Context/CompanyProvider";
import muiTheme from "./styles/muiTheme";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { setupGlobalErrorHandlers } from "./Utils/setupGlobalErrorHandlers";
import { flushQueuedClientErrors } from "./services/clientErrorService";

setupGlobalErrorHandlers();
flushQueuedClientErrors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <CompanyProvider>
        <App />
      </CompanyProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
